module.exports = __webpack_public_path__ + "img/ctrl-hadamard-stub-up--.fcdbd763.svg";